<template>
  <div>
    <img :src="obj.picUrl" class="head-img" />
    <div class="item">
      <div class="item-son">
        <div>
          <div class="item-line">
            <span class="text"></span>
            <div class="title">{{$route.query.name}}</div>
          </div>
          <div v-for="i in level2" :key="i.id">
            <a :href="i.linkUrl" class="item-center">
              <div class="center-tit">
                <div class="center-title">{{i.title}}</div>
                <div class="center-tex" v-if="i.linkFrom.length > 0">来源：{{i.linkFrom}}</div>
              </div>
              <div>
                <img v-lazy="i.picUrl && i.picUrl.length > 0 ? i.picUrl : require(`@/assets/images/default.png`)" class="item-img" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="back" @click="$router.back(-1)">返回专题</div>
  </div>
</template>

<script>
import { wxNewsTitleDetail, wxNewsList } from '@/api/home'
export default {
  data() {
    return {
      obj: {},
      level2: []
    }
  },
  created() {
    wxNewsTitleDetail({
      id: this.$route.query.id
    }).then(res => {
      this.obj = res.body
    })
    wxNewsList({
      pageNum: 1,
      pageSize: 9999,
      titleId: this.$route.query.id,
      groupId: this.$route.query.level2
    }).then(res => {
      this.level2 = res.body.rows
    })
  }
}
</script>

<style lang="scss" scoped>
@function vw($n) {
  @return $n / 7.5 * 1vw;
}

.head-img {
  width: 100%;
  height: vw(274);
}
.item {
  width: 100%;
  position: absolute;
  background: #fff;
  top: vw(245);
  border-radius: vw(33) vw(33) 0 0;
  padding: 0 vw(38);
  box-sizing: border-box;
}
.item-line {
  padding-top: vw(46);
  padding-bottom: vw(46);
  border-bottom: 1px solid #E5E5E5;
  display: flex;
  align-items: center;
}
.item-son:not(:first-child) .item-line {
  border-top: 1px solid #E5E5E5;
}
.text {
  display: inline-block;
  width: vw(5);
  height: vw(40);
  border-radius: vw(2);
  background-color: #FF281A;
}
.title{
  display: inline-block;
  font-size: vw(36);
  color: #000;
  font-weight: bold;
  margin-left: vw(20);
}
.item-center {
  margin-top: vw(38);
  margin-bottom: vw(60);
  display: flex;
  justify-content: space-around;
  text-decoration: none;
}
.center-tit {
  width: vw(410);
  font-size: vw(33);
  .center-title {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    height: vw(88);
    -webkit-box-orient: vertical;
    display: -webkit-box;
    color: #000;
    line-height: vw(44);
  }
}
.center-tex {
  margin-top: vw(34);
  font-size: vw(25);
  color: #B2B2B2;
}

.item-img {
  width: vw(204);
  height: vw(148);
  border-radius: 2.2vw;
}

.back {
  position: fixed;
  bottom: vw(40);
  right: vw(28);
  width: vw(90);
  height: vw(90);
  border-radius: 50%;
  border: 1px solid #C7C7C7;
  opacity: 0.95;
  background-color: #fff;
  line-height: vw(45);
  text-align: center;
  font-size: vw(33);
  font-weight: bold;
  padding: vw(14);
  text-decoration: none;
  color: #555555;
}
</style>